/** 登录后的页面刷新必须等待提醒关闭，避免提示随登录弹窗一起消失。 */
export async function showInitialPasswordNotice(vm, loginData, english = false) {
  if (!loginData || loginData.must_change_password !== true) return;
  try {
    await vm.$alert(
      english
        ? 'Please click your account in the top-right corner and select Change Password.'
        : '请首次登录后点击右上角账号，在个人信息中修改初始密码。',
      english ? 'Update Your Password' : '初始密码修改提醒',
      {
        confirmButtonText: english ? 'Got It' : '我知道了',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false
      }
    );
  } catch (error) { /* 提醒被关闭不改变已经成功的登录结果。 */ }
}
